import { TicketStatusEnum } from "@/lib/enum/ticket-status.enum";

/**
 * Map of ticket status to color and label
 */
export const ticketStateMap = new Map<TicketStatusEnum, { color: string; label: string }>([
  [TicketStatusEnum.DRAFT, { color: "grey", label: "Draft" }],
  [TicketStatusEnum.OPEN, { color: "green", label: "Open" }],
  [TicketStatusEnum.ARCHIVED, { color: "grey darken-3", label: "Archived" }],
  [TicketStatusEnum.CLOSED, { color: "deep-purple lighten-1", label: "Closed" }]
]);
